import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Col, Row, Container, Button, Card, CardHeader, CardBody, Label } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import Breadcrumbs from "../../components/Common/Breadcrumb";

function AddEdit_LedgerMaster() {
  const API_URL_SAVE = `${API_WEB_URLS.LedgerMaster}/0/token`;
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/LedgerMaster`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/LedgerMasterEdit/Id`;
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/CityMasterById";
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/StateMaster";

  const [state, setState] = useState({
    id: 0,
    FillArrayL: [
      { Id: 20, Name: "Duties and Taxes" },
      { Id: 48, Name: "Party A/C" },
    ],
    CityArray: [],
    StateArray: [],
    FillArray: [],
    formData: {
      Name: "",
      
      Person: "",
      Address: "",
      F_CityMaster: "",
      F_StateMaster: "",
      IFS: "",
      PanNo: "",
      PhoneNo: "",
      MobileNo: "",
      Email: "",
      Fax: "",
      GSTNo: "",
      AccNo: "",
      IsActive: true,
    },
    isProgress: true,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    Fn_FillListData(dispatch, setState, "CityArray", API_URL1 + "/Id/0");
    Fn_FillListData(dispatch, setState, "StateArray", API_URL2 + "/Id/0");
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0");
  }, []);

  // Fetch data when editing
  useEffect(() => {
    const fetchData = async () => {
      const Id = location.state?.Id || 0;

      if (Id > 0) {
        try {
          console.log("Fetching data for Id:", Id);
          const data = await Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
          console.log("Fetched Data:", data);

          // Update state with fetched data
          if (data) {
            setState((prevState) => ({
              ...prevState,
              id: Id,
              formData: { 
                ...data,
                IsActive: data.IsActive === true || data.IsActive === "true" || data.IsActive === 1 || data.IsActive === "1"
              },
            }));
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [dispatch, location.state]);



  // const handleSubmit = (values) => {
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   const formData = new FormData();

  //   Object.keys(values).forEach((key) => {
  //     // Ensure empty values are sent as empty strings instead of null/undefined
  //     const value = values[key] || "";
  //     formData.append(key, value);
  //   });
  //   formData.append("UserId", obj.uid);
  //   formData.append("F_LedgerGroupMaster", 48);

  //   Fn_AddEditData(
  //     dispatch,
  //     setState,
  //     { arguList: { id: state.id, formData } },
  //     API_URL_SAVE,
  //     true,
  //     "memberid",
  //     navigate,
  //     "/LedgerMaster"
  //   );
  // };


  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();

    formData.append("Name", values.Name || "");
    formData.append("Person", values.Person || "");
    formData.append("Address", values.Address || "");
    formData.append("F_CityMaster", values.F_CityMaster || "");
    formData.append("F_StateMaster", values.F_StateMaster || "");
    formData.append("IFS", values.IFS || "");
    formData.append("PanNo", values.PanNo || "");
    formData.append("PhoneNo", values.PhoneNo || "");
    formData.append("MobileNo", values.MobileNo || "");
    formData.append("Email", values.Email || "");
    formData.append("Fax", values.Fax || "");
    formData.append("GSTNo", values.GSTNo || "");
    formData.append("AccNo", values.AccNo || "");
    formData.append("IsActive", values.IsActive ? true : false);
    formData.append("UserId", obj.uid || 0);
    formData.append("F_LedgerGroupMaster", 48);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/LedgerMaster"
    );
  };









  const breadCrumbTitle = state.id > 0 ? "Edit Ledger" : "Add New Ledger";
  const breadcrumbItem = "Ledger Master";

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />
        
        <Row className="justify-content-center">
          <Col lg="10" xl="8">
            <Card className="shadow-sm border-0">
              <CardHeader className="bg-primary text-white text-center py-3">
                <h4 className="mb-0">
                  <i className="fas fa-address-book me-2"></i>
                  {state.id > 0 ? "Edit Ledger Details" : "Add New Ledger"}
                </h4>
              </CardHeader>
              
              <CardBody className="p-4">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize={true}
                  onSubmit={handleSubmit}
                >
                  {({ values, isSubmitting, setFieldValue }) => (
                    <Form>
                      {/* Basic Information */}
                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-user me-1 text-primary"></i>
                              Ledger Name
                            </label>
                            <Field
                              className="form-control form-control-lg"
                              type="text"
                              name="Name"
                              placeholder="Enter ledger name"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-user-tie me-1 text-primary"></i>
                              Contact Person
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Person"
                              placeholder="Enter contact person name"
                            />
                          </div>
                        </Col>
                      </Row>

                     
                         
                    

                      {/* Address Information */}
                      <Row>
                        <Col lg="12" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-map-marker-alt me-1 text-primary"></i>
                              Address
                            </label>
                            <Field
                              as="textarea"
                              className="form-control"
                              name="Address"
                              placeholder="Enter complete address"
                              rows="3"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-map me-1 text-primary"></i>
                              State
                            </label>
                            <Field
                              as="select"
                              className="form-select"
                              name="F_StateMaster"
                            >
                              <option value="">Select State</option>
                              {state.StateArray.map((state) => (
                                <option key={state.Id} value={state.Name}>
                                  {state.Name}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-city me-1 text-primary"></i>
                              City
                            </label>
                             
                            <Field
                              className="form-control"
                              type="text"
                              name="F_CityMaster"
                              placeholder="Enter city name"
                            />
                          </div>
                        </Col>

                         
                      </Row>

                      {/* Contact Information */}
                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                               <i className="fas fa-phone me-1 text-primary"></i>
                               Phone Number
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="PhoneNo"
                              placeholder="Enter phone number"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                               <i className="fas fa-mobile-alt me-1 text-primary"></i>
                               Mobile Number
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="MobileNo"
                              placeholder="Enter mobile number"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                               <i className="fas fa-envelope me-1 text-primary"></i>
                               Email Address
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Email"
                              placeholder="Enter email address"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                               <i className="fas fa-fax me-1 text-primary"></i>
                               Fax Number
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Fax"
                              placeholder="Enter fax number"
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Financial Information */}
                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-university me-1 text-primary"></i>
                              IFS Code
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="IFS"
                              placeholder="Enter IFS Code"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                                <i className="fas fa-id-card me-1 text-primary"></i>
                               PAN Number
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="PanNo"
                              placeholder="Enter PAN Number"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-money-bill-wave me-1 text-primary"></i>
                              GST No
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="GSTNo"
                              placeholder="Enter GST No"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                                                         <label className="form-label fw-semibold text-dark">
                               <i className="fas fa-bank me-1 text-primary"></i>
                               A/C No
                             </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="AccNo"
                              placeholder="Enter A/C No"
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Status Toggle */}
                      <Row>
                        <Col lg="12" className="mb-4">
                          <div className="form-group">
                            <div className="d-flex align-items-center">
                              <Label className="form-label fw-semibold text-dark mb-0 me-3">
                                <i className="fas fa-power-off me-1 text-primary"></i>
                                Is Active
                              </Label>
                              <Field name="IsActive">
                                {({ field }) => (
                                  <div
                                    onClick={() => {
                                      const newValue = !Boolean(field.value);
                                      setFieldValue("IsActive", newValue);
                                    }}
                                    style={{
                                      position: 'relative',
                                      display: 'inline-block',
                                      width: '50px',
                                      height: '26px',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={Boolean(field.value)}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        setFieldValue("IsActive", checked);
                                      }}
                                      onBlur={field.onBlur}
                                      style={{ display: 'none' }}
                                    />
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: Boolean(field.value) ? '#28a745' : '#ccc',
                                        borderRadius: '26px',
                                        transition: 'background-color 0.3s',
                                      }}
                                    />
                                    <div
                                      style={{
                                        position: 'absolute',
                                        top: '3px',
                                        left: Boolean(field.value) ? '27px' : '3px',
                                        width: '20px',
                                        height: '20px',
                                        backgroundColor: '#fff',
                                        borderRadius: '50%',
                                        transition: 'left 0.3s',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                      }}
                                    />
                                  </div>
                                )}
                              </Field>
                            </div>
                            <ErrorMessage
                              name="IsActive"
                              component="div"
                              className="invalid-feedback d-block"
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Action Buttons */}
                      <Row className="mt-4">
                        <Col lg="12">
                          <div className="d-flex gap-2 justify-content-end">
                           
                            <Button
                              type="submit"
                              color="primary"
                              className="px-4"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <i className="fas fa-spinner fa-spin me-1"></i>
                                  {state.id > 0 ? "Updating..." : "Saving..."}
                                </>
                              ) : (
                                <>
                                  <i className={`fas ${state.id > 0 ? 'fa-edit' : 'fa-save'} me-1`}></i>
                                  {state.id > 0 ? "Update Ledger" : "Save Ledger"}
                                </>
                              )}
                            </Button>

                            <Button
                              type="button"
                              color="secondary"
                              outline
                              className="px-4"
                              onClick={() => navigate("/LedgerMaster")}
                            >
                              <i className="fas fa-times me-1"></i>
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AddEdit_LedgerMaster;
